module.exports = __webpack_public_path__ + "static/media/clf.02bb3bb5.svg";